import './index.scss'

const FormLabel = ({ htmlFor, required, className, children }) => {
    const classes = ['form-label']
    if (required) classes.push('form-label--required')
    if (className) classes.push(className)

    const requiredIndicator = required && (
        <>
            <span className="form-label-required-dot" aria-hidden="true" />
            <span className="form-label-required-tooltip" role="tooltip">Campo obligatorio</span>
        </>
    )

    // Pega la última palabra al punto para que el indicador nunca baje solo de línea
    if (required && typeof children === 'string') {
        const words = children.split(' ')
        const lastWord = words.pop()
        return (
            <label htmlFor={htmlFor} className={classes.join(' ')}>
                {words.length > 0 && `${words.join(' ')} `}
                <span className="form-label-required-nowrap">
                    {lastWord}
                    {requiredIndicator}
                </span>
            </label>
        )
    }

    return (
        <label htmlFor={htmlFor} className={classes.join(' ')}>
            {children}
            {requiredIndicator}
        </label>
    )
}

export default FormLabel
